// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-content {
  padding-left: 15rem;
  padding-right: 15rem;
  max-width: 1512px;
  margin: 0 auto;
}

.about-page-wrapper {
  width: 100%;
  margin: 0 auto;
}

.about-header {
  background-color: #458BEA;
  color: white;
  display: flex;
  align-items: center; /* Align content at the top */
  justify-content: center;
  text-align: center;
  width: 100%;
  padding: 2rem 0 8rem 0; /* Add padding to top and bottom for spacing */
}

.about-header-content {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center; /* Center content vertically within its container */
  width: 100%;
  max-width: 1512px;
  margin: 0 auto;
}

.about-header h2 {
  margin: 0 0 1rem 0; /* Add margin below the heading */
  font-family: var(--h-2-font-family);
  font-size: var(--h-2-font-size);
  font-weight: var(--h-2-font-weight);
  line-height: var(--h-2-line-height);
  padding-top: 5%;
  padding-bottom: 1rem;
  text-align: center;
}

.about-header-content p {
  width: 78%; /* Ensure the paragraph text takes up about 78% of the screen */
  margin: 0 auto; /* Center align the paragraph */
  font-size: var(--p-font-size);
  font-weight: var(--p-font-weight);
  line-height: var(--p-line-height);
  letter-spacing: var(--p-letter-spacing);
  text-align: left;
}

.about-page-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 3rem;
  padding-bottom: 3rem;
}

.column-left {
  width: 50%; /* Adjust width as needed */
  display: flex;
  gap: 1rem;
  flex-direction: column;
}

.column-right {
  width: 50%; /* Adjust width as needed */
  display: flex;
  gap: 1rem;
  flex-direction: column;
}

.column-left img {
  max-width: 85%; /* Ensure image fills its container */
  height: auto;
}

.mission-text {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto; /* Center align the paragraph */
  font-size: var(--p-font-size);
  font-weight: var(--p-font-weight);
  line-height: var(--p-line-height);
  letter-spacing: var(--p-letter-spacing);
  text-align: left;
}

.mission-text h2 {
  color: #454545;
  text-align: left;
  font-family: Georgia;
  font-size: 50px;
  font-style: normal;
  font-weight: 700;
  line-height: var(--h-2-line-height);
}

.mission-text p {
  color: #454545;
  font-family: var(--p-font-family);
  font-size: var(--p-font-size);
  font-style: var(--p-font-style);
  font-weight: var(--p-font-weight);
  letter-spacing: var(--p-letter-spacing);
  line-height: var(--p-line-height);
  padding-top: 2rem;
  text-align: left;
}

.light-blue {
  width: 100%;
  background-color: #E4EEFC;
}

.light-blue .boxed-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 5rem 15rem;
  max-width: 1512px;
  margin: 0 auto;
}

.light-blue h2 {
  color: #454545;
  font-family: Georgia;
  font-size: 50px;
  font-style: normal;
  font-weight: 700;
}

.extra-padding {
  padding: 2rem 0;
}

.light-blue ul {
  list-style-type: disc;
}

.light-blue li::marker {
  color: #458bea;
  font-size: 3rem;
}

.custom-list {
  list-style: none; /* Remove default list bullets */
  color: #454545;
  font-family: var(--p-font-family);
  font-size: 20px;
  font-style: var(--p-font-style);
  font-weight: var(--p-font-weight);
  letter-spacing: var(--p-letter-spacing);
  line-height: 1.5;
  margin-bottom: 1rem;
  text-align: left;
}

.custom-list li {
  display: flex; /* Use flexbox for alignment */
  align-items: center; /* Center items vertically */
  margin-bottom: 2.5rem; /* Space between list items */
}

.bullet {
  width: 1.5rem; /* Size of the bullet */
  height: 1.5rem; /* Size of the bullet */
  background-color: #458BEA; /* Bullet color */
  border-radius: 50%; /* Make it a circle */
  margin-right: 1rem; /* Space between bullet and text */
  flex-shrink: 0; /* Prevent shrinking of the bullet */
}

.text {
  line-height: 1.5; /* Adjust line height if needed */
}

.team-text {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto; /* Center align the paragraph */
  font-size: var(--p-font-size);
  font-weight: var(--p-font-weight);
  line-height: var(--p-line-height);
  letter-spacing: var(--p-letter-spacing);
  text-align: left;
}

.team-text h2 {
  color: #454545;
  text-align: left;
  font-family: Georgia;
  font-size: 50px;
  font-style: normal;
  font-weight: 700;
  line-height: var(--h-2-line-height);
}

.team-text p {
  color: #454545;
  font-family: var(--p-font-family);
  font-size: var(--p-font-size);
  font-style: var(--p-font-style);
  font-weight: var(--p-font-weight);
  letter-spacing: var(--p-letter-spacing);
  line-height: var(--p-line-height);
  padding-top: 2rem;
  text-align: left;
}

.column-right img {
  max-width: 85%; /* Ensure image fills its container */
  height: auto;
  margin: 0 auto;
}

.full-section {
  padding-top: 3rem;
  padding-bottom: 3rem;
  width: 100%;
}

.full-section .boxed-content {
  max-width: 1512px;
  margin: 0 auto;
  padding-left: 15rem;
  padding-right: 15rem;
}

.full-section h2 {
  color: #454545;
  text-align: left;
  font-family: Georgia;
  font-size: 50px;
  font-style: normal;
  font-weight: 700;
  line-height: var(--h-2-line-height);
}

.full-section p {
  color: #454545;
  font-family: var(--p-font-family);
  font-size: 18px;
  font-style: var(--p-font-style);
  font-weight: var(--p-font-weight);
  letter-spacing: var(--p-letter-spacing);
  line-height: var(--p-line-height);
  padding-top: 2rem;
  text-align: left;
}

.full-section li {
  color: #454545;
  font-family: var(--p-font-family);
  font-size: 18px;
  font-style: var(--p-font-style);
  font-weight: var(--p-font-weight);
  letter-spacing: var(--p-letter-spacing);
  line-height: var(--p-line-height);
  padding-top: 2rem;
  text-align: left;
  margin-left: 2rem;
}

.light-blue p {
  color: #454545;
  font-family: var(--p-font-family);
  font-size: 18px;
  font-style: var(--p-font-style);
  font-weight: var(--p-font-weight);
  letter-spacing: var(--p-letter-spacing);
  line-height: var(--p-line-height);
  padding-top: 2rem;
  text-align: left;
}

.line {
  background-color: #d9d9d9;
  height: 1px;
  width: 100%;
  margin-top: 2rem;
  margin-bottom: 2rem;
}

/* Responsive Styles */
@media (max-width: 1224px) {
  .about-page-section {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .column-left,
  .column-right {
    width: 100%;
  }

  .column-left img,
  .column-right img {
    max-width: 85%;
    height: auto;
    margin: 0 auto;
  }

  .mission-text {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-top: 2rem;
    margin: 0 auto; /* Center align the paragraph */
    font-size: var(--p-font-size);
    font-weight: var(--p-font-weight);
    line-height: var(--p-line-height);
    letter-spacing: var(--p-letter-spacing);
    text-align: left;
  }

  .page-content {
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .light-blue .boxed-content {
    padding-left: 5rem;
    padding-right: 5rem;
  }
}

@media (max-width: 768px) {
  .about-page-section {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .column-left,
  .column-right {
    width: 100%;
  }

  .page-content {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .light-blue .boxed-content {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/About/style.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,mBAAmB,EAAE,6BAA6B;EAClD,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,sBAAsB,EAAE,8CAA8C;AACxE;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB,EAAE,mDAAmD;EAC5E,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB,EAAE,iCAAiC;EACrD,mCAAmC;EACnC,+BAA+B;EAC/B,mCAAmC;EACnC,mCAAmC;EACnC,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,UAAU,EAAE,+DAA+D;EAC3E,cAAc,EAAE,+BAA+B;EAC/C,6BAA6B;EAC7B,iCAAiC;EACjC,iCAAiC;EACjC,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,UAAU,EAAE,2BAA2B;EACvC,aAAa;EACb,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,UAAU,EAAE,2BAA2B;EACvC,aAAa;EACb,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,cAAc,EAAE,qCAAqC;EACrD,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,cAAc,EAAE,+BAA+B;EAC/C,6BAA6B;EAC7B,iCAAiC;EACjC,iCAAiC;EACjC,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,6BAA6B;EAC7B,+BAA+B;EAC/B,iCAAiC;EACjC,uCAAuC;EACvC,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB,EAAE,gCAAgC;EAClD,cAAc;EACd,iCAAiC;EACjC,eAAe;EACf,+BAA+B;EAC/B,iCAAiC;EACjC,uCAAuC;EACvC,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa,EAAE,8BAA8B;EAC7C,mBAAmB,EAAE,4BAA4B;EACjD,qBAAqB,EAAE,6BAA6B;AACtD;;AAEA;EACE,aAAa,EAAE,uBAAuB;EACtC,cAAc,EAAE,uBAAuB;EACvC,yBAAyB,EAAE,iBAAiB;EAC5C,kBAAkB,EAAE,qBAAqB;EACzC,kBAAkB,EAAE,kCAAkC;EACtD,cAAc,EAAE,oCAAoC;AACtD;;AAEA;EACE,gBAAgB,EAAE,iCAAiC;AACrD;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,cAAc,EAAE,+BAA+B;EAC/C,6BAA6B;EAC7B,iCAAiC;EACjC,iCAAiC;EACjC,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,6BAA6B;EAC7B,+BAA+B;EAC/B,iCAAiC;EACjC,uCAAuC;EACvC,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc,EAAE,qCAAqC;EACrD,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,eAAe;EACf,+BAA+B;EAC/B,iCAAiC;EACjC,uCAAuC;EACvC,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,eAAe;EACf,+BAA+B;EAC/B,iCAAiC;EACjC,uCAAuC;EACvC,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,eAAe;EACf,+BAA+B;EAC/B,iCAAiC;EACjC,uCAAuC;EACvC,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;;IAEE,WAAW;EACb;;EAEA;;IAEE,cAAc;IACd,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;IACjB,cAAc,EAAE,+BAA+B;IAC/C,6BAA6B;IAC7B,iCAAiC;IACjC,iCAAiC;IACjC,uCAAuC;IACvC,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;AACF","sourcesContent":[".page-content {\n  padding-left: 15rem;\n  padding-right: 15rem;\n  max-width: 1512px;\n  margin: 0 auto;\n}\n\n.about-page-wrapper {\n  width: 100%;\n  margin: 0 auto;\n}\n\n.about-header {\n  background-color: #458BEA;\n  color: white;\n  display: flex;\n  align-items: center; /* Align content at the top */\n  justify-content: center;\n  text-align: center;\n  width: 100%;\n  padding: 2rem 0 8rem 0; /* Add padding to top and bottom for spacing */\n}\n\n.about-header-content {\n  padding: 1rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center; /* Center content vertically within its container */\n  width: 100%;\n  max-width: 1512px;\n  margin: 0 auto;\n}\n\n.about-header h2 {\n  margin: 0 0 1rem 0; /* Add margin below the heading */\n  font-family: var(--h-2-font-family);\n  font-size: var(--h-2-font-size);\n  font-weight: var(--h-2-font-weight);\n  line-height: var(--h-2-line-height);\n  padding-top: 5%;\n  padding-bottom: 1rem;\n  text-align: center;\n}\n\n.about-header-content p {\n  width: 78%; /* Ensure the paragraph text takes up about 78% of the screen */\n  margin: 0 auto; /* Center align the paragraph */\n  font-size: var(--p-font-size);\n  font-weight: var(--p-font-weight);\n  line-height: var(--p-line-height);\n  letter-spacing: var(--p-letter-spacing);\n  text-align: left;\n}\n\n.about-page-section {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 3rem;\n  padding-bottom: 3rem;\n}\n\n.column-left {\n  width: 50%; /* Adjust width as needed */\n  display: flex;\n  gap: 1rem;\n  flex-direction: column;\n}\n\n.column-right {\n  width: 50%; /* Adjust width as needed */\n  display: flex;\n  gap: 1rem;\n  flex-direction: column;\n}\n\n.column-left img {\n  max-width: 85%; /* Ensure image fills its container */\n  height: auto;\n}\n\n.mission-text {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin: 0 auto; /* Center align the paragraph */\n  font-size: var(--p-font-size);\n  font-weight: var(--p-font-weight);\n  line-height: var(--p-line-height);\n  letter-spacing: var(--p-letter-spacing);\n  text-align: left;\n}\n\n.mission-text h2 {\n  color: #454545;\n  text-align: left;\n  font-family: Georgia;\n  font-size: 50px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: var(--h-2-line-height);\n}\n\n.mission-text p {\n  color: #454545;\n  font-family: var(--p-font-family);\n  font-size: var(--p-font-size);\n  font-style: var(--p-font-style);\n  font-weight: var(--p-font-weight);\n  letter-spacing: var(--p-letter-spacing);\n  line-height: var(--p-line-height);\n  padding-top: 2rem;\n  text-align: left;\n}\n\n.light-blue {\n  width: 100%;\n  background-color: #E4EEFC;\n}\n\n.light-blue .boxed-content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 5rem 15rem;\n  max-width: 1512px;\n  margin: 0 auto;\n}\n\n.light-blue h2 {\n  color: #454545;\n  font-family: Georgia;\n  font-size: 50px;\n  font-style: normal;\n  font-weight: 700;\n}\n\n.extra-padding {\n  padding: 2rem 0;\n}\n\n.light-blue ul {\n  list-style-type: disc;\n}\n\n.light-blue li::marker {\n  color: #458bea;\n  font-size: 3rem;\n}\n\n.custom-list {\n  list-style: none; /* Remove default list bullets */\n  color: #454545;\n  font-family: var(--p-font-family);\n  font-size: 20px;\n  font-style: var(--p-font-style);\n  font-weight: var(--p-font-weight);\n  letter-spacing: var(--p-letter-spacing);\n  line-height: 1.5;\n  margin-bottom: 1rem;\n  text-align: left;\n}\n\n.custom-list li {\n  display: flex; /* Use flexbox for alignment */\n  align-items: center; /* Center items vertically */\n  margin-bottom: 2.5rem; /* Space between list items */\n}\n\n.bullet {\n  width: 1.5rem; /* Size of the bullet */\n  height: 1.5rem; /* Size of the bullet */\n  background-color: #458BEA; /* Bullet color */\n  border-radius: 50%; /* Make it a circle */\n  margin-right: 1rem; /* Space between bullet and text */\n  flex-shrink: 0; /* Prevent shrinking of the bullet */\n}\n\n.text {\n  line-height: 1.5; /* Adjust line height if needed */\n}\n\n.team-text {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin: 0 auto; /* Center align the paragraph */\n  font-size: var(--p-font-size);\n  font-weight: var(--p-font-weight);\n  line-height: var(--p-line-height);\n  letter-spacing: var(--p-letter-spacing);\n  text-align: left;\n}\n\n.team-text h2 {\n  color: #454545;\n  text-align: left;\n  font-family: Georgia;\n  font-size: 50px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: var(--h-2-line-height);\n}\n\n.team-text p {\n  color: #454545;\n  font-family: var(--p-font-family);\n  font-size: var(--p-font-size);\n  font-style: var(--p-font-style);\n  font-weight: var(--p-font-weight);\n  letter-spacing: var(--p-letter-spacing);\n  line-height: var(--p-line-height);\n  padding-top: 2rem;\n  text-align: left;\n}\n\n.column-right img {\n  max-width: 85%; /* Ensure image fills its container */\n  height: auto;\n  margin: 0 auto;\n}\n\n.full-section {\n  padding-top: 3rem;\n  padding-bottom: 3rem;\n  width: 100%;\n}\n\n.full-section .boxed-content {\n  max-width: 1512px;\n  margin: 0 auto;\n  padding-left: 15rem;\n  padding-right: 15rem;\n}\n\n.full-section h2 {\n  color: #454545;\n  text-align: left;\n  font-family: Georgia;\n  font-size: 50px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: var(--h-2-line-height);\n}\n\n.full-section p {\n  color: #454545;\n  font-family: var(--p-font-family);\n  font-size: 18px;\n  font-style: var(--p-font-style);\n  font-weight: var(--p-font-weight);\n  letter-spacing: var(--p-letter-spacing);\n  line-height: var(--p-line-height);\n  padding-top: 2rem;\n  text-align: left;\n}\n\n.full-section li {\n  color: #454545;\n  font-family: var(--p-font-family);\n  font-size: 18px;\n  font-style: var(--p-font-style);\n  font-weight: var(--p-font-weight);\n  letter-spacing: var(--p-letter-spacing);\n  line-height: var(--p-line-height);\n  padding-top: 2rem;\n  text-align: left;\n  margin-left: 2rem;\n}\n\n.light-blue p {\n  color: #454545;\n  font-family: var(--p-font-family);\n  font-size: 18px;\n  font-style: var(--p-font-style);\n  font-weight: var(--p-font-weight);\n  letter-spacing: var(--p-letter-spacing);\n  line-height: var(--p-line-height);\n  padding-top: 2rem;\n  text-align: left;\n}\n\n.line {\n  background-color: #d9d9d9;\n  height: 1px;\n  width: 100%;\n  margin-top: 2rem;\n  margin-bottom: 2rem;\n}\n\n/* Responsive Styles */\n@media (max-width: 1224px) {\n  .about-page-section {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n  }\n\n  .column-left,\n  .column-right {\n    width: 100%;\n  }\n\n  .column-left img,\n  .column-right img {\n    max-width: 85%;\n    height: auto;\n    margin: 0 auto;\n  }\n\n  .mission-text {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding-top: 2rem;\n    margin: 0 auto; /* Center align the paragraph */\n    font-size: var(--p-font-size);\n    font-weight: var(--p-font-weight);\n    line-height: var(--p-line-height);\n    letter-spacing: var(--p-letter-spacing);\n    text-align: left;\n  }\n\n  .page-content {\n    padding-left: 5rem;\n    padding-right: 5rem;\n  }\n\n  .light-blue .boxed-content {\n    padding-left: 5rem;\n    padding-right: 5rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .about-page-section {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n  }\n\n  .column-left,\n  .column-right {\n    width: 100%;\n  }\n\n  .page-content {\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n  }\n\n  .light-blue .boxed-content {\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
